import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button
} from '@mui/material';
import {
  School as ProgramsIcon,
  People as EnrollmentsIcon,
  CalendarToday as SessionsIcon,
  Email as EmailIcon,
  Event as EventIcon
} from '@mui/icons-material';

function AdminDashboard() {
  const adminSections = [
    {
      title: 'Programs',
      description: 'Create, edit, and manage all programs (classes and events)',
      icon: <ProgramsIcon sx={{ fontSize: 60, color: 'primary.main' }} />,
      link: '/admin/programs',
      color: '#2d5a42'
    },
    {
      title: 'Email Parents',
      description: 'Send emails to all parents or program enrollees',
      icon: <EmailIcon sx={{ fontSize: 60, color: 'primary.main' }} />,
      link: '/admin/email',
      color: '#2d5a42'
    }
  ];

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', pt: 12, pb: 4 }}>
      <Container maxWidth="lg">
        <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
          Admin Dashboard
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Manage your programs, sessions, and enrollments
        </Typography>

        <Grid container spacing={3} sx={{ mt: 2 }}>
          {adminSections.map((section) => (
            <Grid item xs={12} sm={6} md={4} key={section.title}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4
                  }
                }}
              >
                <CardContent sx={{ flexGrow: 1, textAlign: 'center', pt: 4 }}>
                  {section.icon}
                  <Typography variant="h5" component="h2" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
                    {section.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {section.description}
                  </Typography>
                </CardContent>
                <CardActions sx={{ justifyContent: 'center', pb: 3 }}>
                  <Button
                    component={Link}
                    to={section.link}
                    variant="contained"
                    sx={{
                      bgcolor: section.color,
                      '&:hover': { bgcolor: '#1e4034' }
                    }}
                  >
                    Manage {section.title}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default AdminDashboard;
